"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var hooks_1 = require("../../../mantine-hooks/src");
var Overlay_1 = require("../Overlay/Overlay");
var Transition_1 = require("../Transition/Transition");
var Loader_1 = require("../Loader/Loader");
var LoadingOverlay_styles_1 = __importDefault(require("./LoadingOverlay.styles"));
function LoadingOverlay(_a) {
    var className = _a.className, visible = _a.visible, _b = _a.loaderProps, loaderProps = _b === void 0 ? {} : _b, _c = _a.overlayOpacity, overlayOpacity = _c === void 0 ? 0.75 : _c, overlayColor = _a.overlayColor, themeOverride = _a.themeOverride, _d = _a.transitionDuration, transitionDuration = _d === void 0 ? 200 : _d, _e = _a.zIndex, zIndex = _e === void 0 ? 1000 : _e, style = _a.style, others = __rest(_a, ["className", "visible", "loaderProps", "overlayOpacity", "overlayColor", "themeOverride", "transitionDuration", "zIndex", "style"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = LoadingOverlay_styles_1.default();
    var reduceMotion = hooks_1.useReducedMotion();
    var duration = reduceMotion ? 1 : transitionDuration;
    return (react_1.default.createElement(Transition_1.Transition, { duration: duration, mounted: visible, transition: "fade", themeOverride: themeOverride }, function (transitionStyles) { return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.loadingOverlay, className), style: __assign(__assign(__assign({}, transitionStyles), style), { zIndex: zIndex }) }, others),
        react_1.default.createElement(Loader_1.Loader, __assign({ themeOverride: themeOverride, style: { zIndex: zIndex + 1 } }, loaderProps)),
        react_1.default.createElement(Overlay_1.Overlay, { opacity: overlayOpacity, color: overlayColor || (theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.white), zIndex: zIndex }))); }));
}
exports.LoadingOverlay = LoadingOverlay;
LoadingOverlay.displayName = '@mantine/core/LoadingOverlay';
